import { handleActions } from 'redux-actions';
import {
    GET_ORDER_PREFERENCES,
    GET_ORDER_PREFERENCES_SUCCESS,
    GET_ORDER_PREFERENCES_FAILURE,
} from '../actions/orderPreferencesActions';

const defaultState = {
    data: null,
    isFetching: false,
    error: null,
};

const orderPreferencesReducer = (state = defaultState, action) => {
    switch (action.type) {
        case GET_ORDER_PREFERENCES:
            console.log('orderPreferencesReducer: GET_ORDER_PREFERENCES', state);
            return {
                ...state,
                isFetching: true,
                error: null,
            };
        case GET_ORDER_PREFERENCES_SUCCESS:
            console.log('orderPreferencesReducer: SUCCESS', action.payload);
            return {
                ...state,
                data: action.payload,
                isFetching: false,
                error: null,
            };
        case GET_ORDER_PREFERENCES_FAILURE:
            console.log('orderPreferencesReducer: FAILURE', action.payload);
            return {
                ...state,
                isFetching: false,
                error: action.payload,
            };
        default:
            // console.log('orderPreferencesReducer: default', state);
            return state;
    }
};

export default orderPreferencesReducer;
